import VyjadreniaConfigPage from './VyjadreniaConfigPage';

export default VyjadreniaConfigPage;
